import React from "react";
import { Label } from "reactstrap";
import withStyles from "isomorphic-style-loader/withStyles";
import classNames from "classnames";

import { ServiceCallerProps } from "../../composition";
import { IMessage, messageStatus } from "../../../types/IMessage";
import IUser from "../../../types/services/IUser";
import {
  formatMessengerMessageTime,
  stripLeadingLineBreaks,
} from "../../../utils/helpers";
import s from "./styles.scss";

interface Props extends ServiceCallerProps {
  message: IMessage;
  donor: IUser;
  charityName: string;
  lastMessage: boolean;

  onClick: (message: IMessage) => void;
}

class MessageBubble extends React.PureComponent<Props> {
  handleClick = (): void => {
    this.props.onClick(this.props.message);
  };

  render() {
    const { message, lastMessage } = this.props;
    const status = messageStatus(message);
    const showStatus =
      message.sentFromCharity && (lastMessage || Boolean(message.error));

    return (
      <div
        className={classNames(
          s.wrap,
          message.sentFromCharity && s.wrapSent
        )}
      >
        <div
          className={classNames(
            s.container,
            message.sentFromCharity && s.sentContainer
          )}
          onClick={this.handleClick}
        >
          <div
            className={classNames(
              s.message,
              message.sentFromCharity ? s.sent : s.received
            )}
          >
            <Label>{stripLeadingLineBreaks(message.content)}</Label>
            {message.date != null && (
              <span className={s.messageTime}>
                {formatMessengerMessageTime(message.date)}
              </span>
            )}
          </div>
          {message.sentFromCharity && !message.sent && !message.sending && (
            <div className={s.alert}>
              <i className={"fa fa-exclamation " + s.exclamationIcon} />
            </div>
          )}
        </div>
        {showStatus && (
          <span
            className={classNames(s.spanMessage, message.error && s.noSent)}
          >
            {status}
          </span>
        )}
      </div>
    );
  }
}

export default withStyles(s)(MessageBubble);
